import { render } from "./GlobalLayout.vue?vue&type=template&id=41c762b4"
import script from "./GlobalLayout.vue?vue&type=script&lang=js"
export * from "./GlobalLayout.vue?vue&type=script&lang=js"

import "./GlobalLayout.vue?vue&type=style&index=0&id=41c762b4&lang=less"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__